import { Skeleton } from '@nextui-org/react'

export function OrderMetaLoader() {
  return (
    <div className="[&amp;>*:not(:first-child)]:pl-0 [&amp;>*:not(:first-child)]:pt-6 md:[&amp;>*:not(:first-child)]:pl-10 md:[&amp;>*:not(:first-child)]:pt-0 grid space-y-6 divide-y md:flex md:justify-between md:space-x-10 md:space-y-0 md:divide-x md:divide-y-0">
      <div className="w-full space-y-4">
        <Skeleton className="w-2/5">
          <div className="h-4 w-2/5 bg-default-200"></div>
        </Skeleton>
        <Skeleton className="w-4/5">
          <div className="h-3 w-4/5 bg-default-200"></div>
        </Skeleton>
      </div>
      <div className="w-full space-y-4">
        <Skeleton className="w-2/5">
          <div className="h-4 w-2/5 bg-default-200"></div>
        </Skeleton>
        <Skeleton className="w-4/5">
          <div className="h-3 w-4/5 bg-default-200"></div>
        </Skeleton>
      </div>
      <div className="w-full space-y-4">
        <Skeleton className="w-2/5">
          <div className="h-4 w-2/5 bg-default-200"></div>
        </Skeleton>
        <Skeleton className="w-4/5">
          <div className="h-3 w-4/5 bg-default-200"></div>
        </Skeleton>
      </div>
      <div className="w-full space-y-4">
        <Skeleton className="w-3/5">
          <div className="h-4 w-2/5 bg-default-200"></div>
        </Skeleton>
        <Skeleton className="w-5/5">
          <div className="h-3 w-4/5 bg-default-200"></div>
        </Skeleton>
      </div>
    </div>
  )
}

export default OrderMetaLoader
